import React from 'react';
import logo from '../../assets/logo.png';

const ResetSuccess = ({ setAuthType }) => {
  return (
    <>
      <>
        <img src={logo} alt="Postager Logo" />
        <p className="font-semibold">Password Reset</p>
      </>
      <form className="space-y-5 px-7 w-full pt-5">
        <p className="text-sm text-center">
          Your Password Has Been Successfully Reset
          <br />
          <span>Click Below To Login</span>
        </p>

        <div className="flex flex-col justify-center items-center w-full space-y-3">
          <button
            className="text-white bg-darkblue hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-md text-sm w-[85%] px-5 py-2.5 text-center"
            onClick={() => setAuthType('login')}
          >
            Continue
          </button>

          {/* <a
            href="#"
            className="text-sm hover:underline"
            onClick={() => setAuthType('login')}
          >
            Back To Login Page
          </a> */}
        </div>
      </form>
    </>
  );
};

export default ResetSuccess;
